var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Broken/Wallet"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wallet"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.9397 0C29.3127 0 33.6842 4.47121 33.6842 9.96869V22.0313C33.6842 27.5288 29.3127 32 23.9397 32C23.32 32 22.8169 31.4853 22.8169 30.8512C22.8169 30.217 23.32 29.7024 23.9397 29.7024C28.0747 29.7024 31.4386 26.262 31.4386 22.0313V12.4042H25.9084C24.0924 12.4057 22.6118 13.9191 22.6103 15.7787C22.6118 17.6382 24.0924 19.1516 25.9084 19.1531H28.2064C28.8262 19.1531 29.3292 19.6678 29.3292 20.3019C29.3292 20.9361 28.8262 21.4508 28.2064 21.4508H25.9084C22.8529 21.4492 20.3662 18.905 20.3647 15.7787C20.3662 12.6523 22.8529 10.1081 25.9084 10.1066H31.4386V9.96869C31.4386 5.73797 28.0747 2.29764 23.9397 2.29764H9.74297C6.41048 2.29764 3.61394 4.54626 2.63935 7.62663H17.4394C18.0592 7.62663 18.5622 8.1413 18.5622 8.77545C18.5622 9.41113 18.0592 9.92427 17.4394 9.92427H2.25011L2.24561 9.96869V22.0313C2.24561 26.262 5.60805 29.7024 9.74297 29.7024H16.8855C17.5053 29.7024 18.0083 30.217 18.0083 30.8512C18.0083 31.4853 17.5053 32 16.8855 32H9.74297C4.36996 32 0 27.5288 0 22.0313V9.96869C0 4.47121 4.36996 0 9.74297 0H23.9397ZM26.6623 14.5263C27.2821 14.5263 27.7851 15.041 27.7851 15.6751C27.7851 16.3093 27.2821 16.8239 26.6623 16.8239H26.1518C25.532 16.8239 25.029 16.3093 25.029 15.6751C25.029 15.041 25.532 14.5263 26.1518 14.5263H26.6623Z",
    fill: "url(#paint0_linear_82_4596)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_82_4596",
    x1: 0.589473,
    y1: 3.20349e-7,
    x2: 29.9519,
    y2: 34.2266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80FCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#EFCE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5DFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/Wallet.588b4133f06b168540d87df0e69b08ef.svg";
export { ForwardRef as ReactComponent };